import cross from '../../images/icon-cross.svg';
import check from '../../images/icon-check.svg';
import './list.css';

const List = ({list, id, time, isDone, mark, del, modes, provided}) => {


    const eleShow = () => {
        document.querySelector(`#delete${id}`).classList.remove("delete");
    }
    const eleHide = () => {
        document.querySelector(`#delete${id}`).classList.add("delete");
    }
    const isCompleted = () => {
        mark(time);
    }

    const onRemove = () => {
        del(time)
    }
    return(
        <div className={modes ? "list_todo" : "list_lights"} onMouseOver={eleShow} onMouseLeave={eleHide} {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef}>
            <div className={ isDone ? "checked completed": "checked"} id={"check" + id} onClick={isCompleted}>
                {isDone ? <img src={check} alt="check" /> : ""}
            </div>
            <div className={isDone ? "content done": "content"} id={"content" + id}> {list}</div>
            <span style={{cursor: "pointer"}} className="delete" id={"delete" + id} onClick={onRemove}>
                <img src={cross} alt="delete"/>
            </span>
        </div>
    )
}

export default List;